"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCorrespondsHours = exports.isTravel = void 0;
var constants_1 = require("./constants");
var isTravel = function (type) {
    return Number(type.code) === constants_1.WORKLOG_TYPE_CODES.travel;
};
exports.isTravel = isTravel;
var isCorrespondsHours = function (hours, GPSHours) {
    return GPSHours + constants_1.VALID_TIME_RANGE < hours.approvedHours;
};
exports.isCorrespondsHours = isCorrespondsHours;
